(() => {
  if (customElements.get('rnl-compact-search')) return;
  class CompactSearch extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.input = this.querySelector('[data-rnl-search-query]');
      this.results = this.querySelector('.predictive-search');
      this.version = 0;
      this.input.addEventListener('input', () => {
        this.cancel();
        this.results.hidden = true;
        this.input.setAttribute('aria-expanded', 'false');
        clearTimeout(this.timer);
        if (this.input.value.trim()) this.timer = setTimeout(() => this.search(), 250);
      });
      this.input.addEventListener('focus', () => { if (this.input.value.trim()) this.search(); });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') { this.input.focus(); this.close(); }
        if (!['ArrowDown', 'ArrowUp'].includes(event.key) || this.results.hidden) return;
        const items = [this.input, ...this.results.querySelectorAll('a, button:not([hidden])')];
        const index = items.indexOf(document.activeElement);
        event.preventDefault();
        items[(index + (event.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length].focus();
      });
      this.addEventListener('focusout', () => setTimeout(() => { if (!this.contains(document.activeElement)) this.close(); }, 0));
      this.results.addEventListener('click', event => {
        if (event.target.closest('[data-rnl-search-close]')) { this.input.focus(); this.close(); }
        if (event.target.closest('[data-rnl-search-more]')) this.loadMore();
      });
      this.outside = event => { if (!this.contains(event.target)) this.close(); };
      document.addEventListener('pointerdown', this.outside);
    }
    disconnectedCallback() { this.cancel(); clearTimeout(this.timer); document.removeEventListener('pointerdown', this.outside); }
    cancel() { this.version++; this.controller?.abort(); }
    close() {
      this.cancel(); clearTimeout(this.timer);
      this.removeAttribute('open'); this.results.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
    }
    url(path, term, section) {
      const url = new URL(path, location.origin);
      url.searchParams.set('q', term);
      url.searchParams.set('section_id', section);
      return url;
    }
    async html(url, signal) {
      const response = await fetch(url, { signal });
      if (!response.ok) throw new Error('Search unavailable');
      return new DOMParser().parseFromString(await response.text(), 'text/html');
    }
    async search() {
      this.cancel();
      const term = this.input.value.trim();
      if (!term) return this.close();
      const version = this.version;
      this.controller = new AbortController();
      const url = this.url(this.dataset.routes, term, 'predictive-search');
      url.searchParams.set('resources[type]', 'collection');
      url.searchParams.set('resources[limit]', '10');
      const products = this.url(this.querySelector('form').action, term, 'rnl-search-products');
      products.searchParams.set('type', 'product');
      products.searchParams.set('options[prefix]', 'last');
      try {
        const [collections, page] = await Promise.all([this.html(url, this.controller.signal), this.html(products, this.controller.signal)]);
        if (version !== this.version) return;
        const panel = collections.querySelector('[data-rnl-search-panel]');
        const rows = page.querySelector('[data-rnl-product-page]');
        if (!panel || !rows) throw new Error('Search unavailable');
        this.results.replaceChildren(panel);
        panel.querySelector('[data-rnl-search-products]').append(rows);
        panel.querySelector('[data-rnl-product-count]').textContent = rows.dataset.total;
        panel.querySelector('[data-rnl-search-empty]').hidden = Number(rows.dataset.total) > 0;
        this.next = rows.dataset.next;
        this.updateMore();
        this.setAttribute('open', ''); this.results.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
        panel.querySelector('[data-rnl-search-scroll]').addEventListener('scroll', event => {
          const el = event.target;
          if (el.scrollTop + el.clientHeight >= el.scrollHeight - 100) this.loadMore();
        });
      } catch (error) {
        if (version !== this.version || error.name === 'AbortError') return;
        this.close();
      }
    }
    updateMore() {
      const more = this.results.querySelector('[data-rnl-search-more]');
      if (more) { more.hidden = !this.next; more.disabled = false; }
    }
    async loadMore() {
      if (!this.next || this.loading) return;
      const version = this.version;
      this.loading = true;
      const more = this.results.querySelector('[data-rnl-search-more]');
      more.disabled = true;
      try {
        const url = new URL(this.next, location.origin);
        url.searchParams.set('section_id', 'rnl-search-products'); url.searchParams.set('type', 'product');
        const page = await this.html(url, this.controller.signal);
        if (version !== this.version) return;
        const rows = page.querySelector('[data-rnl-product-page]');
        if (!rows) throw new Error('Search unavailable');
        this.results.querySelector('[data-rnl-product-rows]').append(...rows.querySelector('[data-rnl-product-rows]').children);
        this.next = rows.dataset.next;
      } catch (error) {
        if (version !== this.version) return;
      } finally {
        this.loading = false;
        if (version === this.version) this.updateMore();
      }
    }
  }
  customElements.define('rnl-compact-search', CompactSearch);
})();
